import React from "react";
import { DeepMap, FieldError, useFormContext } from "react-hook-form";
import { Form, Header, FormField } from "semantic-ui-react";
import {
  ControlledInput,
  ControlledTextArea,
  IStrictControlledInputProps,
  IStrictControlledTextAreaProps,
} from "../../../../../components/ControlledForm";
import { ControlledPhoneNumber } from "../../../../../components/global_components/form_components/ControlledPhoneNumber";
import { IInspectionRequestForm } from "./InspectionRequestModalContent";

export default function InspectionRequestOnSiteContactForm({
  name,
  phone,
  instructions,
  errors,
}: {
  name: string;
  phone: string;
  instructions: string;
  errors: DeepMap<IInspectionRequestForm, FieldError>;
}) {
  const { control } = useFormContext();

  return (
    <Form>
      <Header as='h4' className='tw-mb-0'>
        On-site Contact
      </Header>
      <p className='subText tw-mt-0'>Who the inspector should reach out to when they arrive</p>
      <Form.Group widths='equal'>
        <FormField required error={!!errors.onSiteContactName}>
          <ControlledInput<IStrictControlledInputProps<string, {}>>
            name={name}
            control={control}
            label='Name'
            errors={errors}
            rules={{
              validate: {
                _length: (value) => {
                  if (typeof value !== "string") {
                    return false;
                  }
                  const MAX_LENGTH = 191;
                  if (value.length > MAX_LENGTH) {
                    return `Name cannot be greater than ${MAX_LENGTH} characters`;
                  }
                  if (value.length <= 0) {
                    return `Name cannot be blank`;
                  }
                  return true;
                },
              },
            }}
          />
        </FormField>
        <FormField required error={!!errors.onSiteContactPhone}>
          <ControlledPhoneNumber name={phone} control={control} label='Phone Number' errors={errors} required />
        </FormField>
      </Form.Group>
      <FormField error={!!errors.onSiteContactInstructions}>
        <ControlledTextArea<IStrictControlledTextAreaProps>
          control={control}
          errors={errors}
          name={instructions}
          rows={2}
          label='Add a Message for the Inspector'
          placeholder='You can also reach me at xyz email, please buzz 2R when you arrive, etc.'
          rules={{
            validate: {
              _length: (value) => {
                if (typeof value !== "string") {
                  return false;
                }
                const MAX_LENGTH = 191;
                if (value.length > MAX_LENGTH) {
                  return `Message cannot be greater than ${MAX_LENGTH} characters`;
                }
                return true;
              },
            },
          }}
        />
      </FormField>
    </Form>
  );
}
